import { AccessInterval } from '../types/Satellite';

export const getLocalTimeInterval = (interval: AccessInterval): string => {
    return `[${new Date(interval.start * 1000).toLocaleString('de-DE', {
        timeZone: 'UTC',
    })}] - [${new Date(interval.end * 1000).toLocaleString('de-DE', {
        timeZone: 'UTC',
    })}]`;
};
